import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Card, Accordion, Col, Row } from 'react-bootstrap';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useTranslation } from 'react-i18next';
import { AddButton } from '@rd-web-markets/shared/dist/util/buttons';
import useConsultantRole from '@rd-web-markets/shared/dist/hooks/useConsultantRole';
import EditUserAccessModal from './EditUserAccessModal';
import claimGroupService from '../../services/claim_group.service';
import CreateUserAccessModal from '@rd-web-markets/market/dist/claim_schedule_engagement_team/CreateUserAccessModal';
import ContactCard from './ContactCard';
import CreateAccountantCollaboratorModal from './CreateAccountantCollaboratorModal';
import userAccessService from '../../services/user_access.service';
import isPlainObject from '../../helper_functions/isPlainObject';
import { isUserAdmin } from '../../util/user/userUtils';
import { Loader } from '../../util/Loader';
const ClaimScheduleEngagementTeam = _ref => {
  let {
    claimGroup,
    setClaimGroup,
    company,
    claimGroupStepAccess,
    engagementTeam,
    setEngagementTeam,
    onClaimScheduleClientContactParticipationChange
  } = _ref;
  const history = useHistory();
  const {
    t
  } = useTranslation();
  const [userAccessToEdit, setUserAccessToEdit] = useState(null);
  const [aymingContactsOpen, setAymingContactsOpen] = useState(true);
  const [clientContactsOpen, setClientContactsOpen] = useState(true);
  const [accountantsOpen, setAccountantsOpen] = useState(true);
  const [editModalShow, setEditModalShow] = useState(false);
  const [createModalShow, setCreateModalShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [createAccountantCollaboratorModalShow, setCreateAccountantCollaboratorModalShow] = useState(false);
  const [getConsultantRole] = useConsultantRole();
  const user = useSelector(state => state.auth.user);
  const userClaimGroupAbilities = window.MARKET_SETUP.useGetUserClaimGroupAbilities({
    user,
    claimGroup
  });
  const createUserAccess = userAccessService.useCreateUserAccess(claimGroup, setLoading, setClaimGroup, null, setEngagementTeam);

  // Errors are not caught here so the delete confirmation modal can show them and stay open.
  const handleDelete = async userAccessId => {
    await userAccessService.delete(claimGroup.id, userAccessId);
    setClaimGroup({
      ...claimGroup,
      user_accesses: [...claimGroup.user_accesses.filter(ua => ua.id !== userAccessId)]
    });
    setEngagementTeam({
      ...engagementTeam,
      clients: engagementTeam.clients.filter(c => c.user_access.id !== userAccessId),
      accountants: engagementTeam.accountants.filter(c => c.user_access.id !== userAccessId)
    });
  };
  const editUserAccess = async userAccess => {
    setUserAccessToEdit(userAccess);
    setEditModalShow(true);
  };
  const onSubmit = async userAccess => {
    const updatedUserAccess = await userAccessService.update(claimGroup.id, userAccess);
    const updatedClaimGroup = await claimGroupService.get(claimGroup.id);
    setClaimGroup(updatedClaimGroup);
    setEngagementTeam(prev => {
      if (!prev) return {
        clients: [],
        accountants: []
      };
      const isAccountant = updatedUserAccess.roles.includes('accountant');
      const arrayKey = isAccountant ? 'accountants' : 'clients';
      const updatedArray = [...(prev[arrayKey] || [])];

      // Get the fresh user_access from updatedClaimGroup instead of relying on updatedUserAccess alone
      const freshUserAccess = updatedClaimGroup.user_accesses.find(ua => ua.id === updatedUserAccess.id) || updatedUserAccess;
      const newEntry = {
        ...freshUserAccess.user,
        user_access: {
          ...freshUserAccess
        }
      };
      const index = updatedArray.findIndex(e => e.user_access.id === updatedUserAccess.id);
      if (index >= 0) updatedArray[index] = newEntry;else updatedArray.push(newEntry);
      return {
        ...prev,
        [arrayKey]: updatedArray
      };
    });
    setEditModalShow(false);
  };
  const userIsAdmin = isUserAdmin(user);
  if (!engagementTeam) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  const engagementTeamClients = (engagementTeam?.clients || []).filter(c => c.user_access?.included_in_engagement_team === true);
  const engagementTeamAccountants = (engagementTeam?.accountants || []).filter(c => c.user_access?.included_in_engagement_team === true);
  const AccorditionToggle = _ref2 => {
    let {
      title,
      setOpen,
      isOpen,
      eventKey
    } = _ref2;
    const decoratedOnClick = useAccordionButton(eventKey, () => {
      setOpen(!isOpen);
    });
    return /*#__PURE__*/React.createElement(Accordion.Button, {
      onClick: decoratedOnClick,
      as: Card.Header,
      eventKey: "0",
      className: "bg-transparent text-dark cursor-pointer border-bottom border-light d-flex"
    }, /*#__PURE__*/React.createElement("div", {
      className: "accordition-icon me-3"
    }, isOpen ? /*#__PURE__*/React.createElement("span", {
      className: "material-icons md-18"
    }, "expand_more") : /*#__PURE__*/React.createElement("span", {
      className: "material-icons md-18"
    }, "chevron_right")), /*#__PURE__*/React.createElement("b", null, title));
  };
  const renderAymingContacts = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Accordion, {
      defaultActiveKey: "0",
      className: "mb-3"
    }, /*#__PURE__*/React.createElement(AccorditionToggle, {
      title: t('ayming_contacts'),
      setOpen: setAymingContactsOpen,
      isOpen: aymingContactsOpen,
      eventKey: "0"
    }), /*#__PURE__*/React.createElement(Accordion.Collapse, {
      eventKey: "0"
    }, /*#__PURE__*/React.createElement(Row, {
      className: "mt-3"
    }, /*#__PURE__*/React.createElement(Col, {
      md: 3
    }, isPlainObject(claimGroup.admin) ? /*#__PURE__*/React.createElement(ContactCard, {
      canEdit: claimGroupStepAccess.canEditAnyTypeOfUser,
      showAymingLogo: true,
      user: claimGroup.admin,
      roles: ['Manager'],
      editUserAccess: editUserAccess,
      handleDelete: handleDelete
    }) : /*#__PURE__*/React.createElement("p", {
      className: "danger"
    }, t('please_add_manager_to_company'))), claimGroup.consultant_roles.map((consultant, index) => /*#__PURE__*/React.createElement(Col, {
      md: 3,
      key: index
    }, /*#__PURE__*/React.createElement(ContactCard, {
      canEdit: claimGroupStepAccess.canEditAnyTypeOfUser,
      showAymingLogo: true,
      user: consultant.user,
      roles: [getConsultantRole(consultant.role)],
      editUserAccess: editUserAccess,
      handleDelete: handleDelete
    })))))), /*#__PURE__*/React.createElement(Accordion, {
      defaultActiveKey: "0",
      className: "mb-3"
    }, /*#__PURE__*/React.createElement(AccorditionToggle, {
      title: t('client_contacts'),
      setOpen: setClientContactsOpen,
      isOpen: clientContactsOpen,
      eventKey: "0"
    }), /*#__PURE__*/React.createElement(Accordion.Collapse, {
      eventKey: "0"
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
      className: "pt-2 d-flex justify-content-end"
    }, claimGroupStepAccess.canCreateNewCustomerUsers && /*#__PURE__*/React.createElement(AddButton, {
      isImmutableUnderReview: true,
      variant: "primary",
      onClick: () => history.push('/admin/users/new', {
        from: location.pathname
      }),
      className: "ms-auto me-3",
      text: t(window.MARKET_CONSTANTS.ADD_USER_BUTTON_TEXT),
      disabled: !claimGroupStepAccess.canCreateNewCustomerUsers
    }), /*#__PURE__*/React.createElement(AddButton, {
      isImmutableUnderReview: true,
      variant: "primary",
      onClick: () => setCreateModalShow(true),
      className: `${userIsAdmin ? '' : 'ms-auto '} me-3`,
      text: t(window.MARKET_CONSTANTS.ADD_CONTACT_BUTTON_TEXT),
      disabled: !claimGroupStepAccess.canEditAnyTypeOfUser
    })), /*#__PURE__*/React.createElement(Row, {
      className: "mt-3"
    }, engagementTeamClients.map(client => /*#__PURE__*/React.createElement(Col, {
      md: 3
    }, /*#__PURE__*/React.createElement(ContactCard, {
      canEdit: claimGroupStepAccess.canEditAnyTypeOfUser,
      user: client,
      roles: client.user_access.roles,
      editUserAccess: editUserAccess,
      handleDelete: handleDelete,
      userAccess: client.user_access
    }))))))));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, claimGroupStepAccess.canEditAnyTypeOfUser && createModalShow && /*#__PURE__*/React.createElement(CreateUserAccessModal, {
    title: 'add_contact',
    onHide: () => setCreateModalShow(false),
    show: createModalShow,
    onSubmit: createUserAccess,
    company: company,
    claimGroup: claimGroup
  }), claimGroupStepAccess.canAddAccountants && createAccountantCollaboratorModalShow && /*#__PURE__*/React.createElement(CreateAccountantCollaboratorModal, {
    title: 'add_accountant_collaborator',
    onHide: () => setCreateAccountantCollaboratorModalShow(false),
    show: createAccountantCollaboratorModalShow,
    onSubmit: createUserAccess,
    company: company,
    claimGroup: claimGroup
  }), userAccessToEdit && claimGroupStepAccess.canEditAnyTypeOfUser && editModalShow && /*#__PURE__*/React.createElement(EditUserAccessModal, {
    company: company,
    claimGroup: claimGroup,
    setClaimGroup: setClaimGroup,
    title: t('edit_contact'),
    onHide: () => setEditModalShow(false),
    show: editModalShow,
    userAccess: userAccessToEdit,
    onClaimScheduleClientContactParticipationChange: onClaimScheduleClientContactParticipationChange,
    onSubmit: onSubmit
  }), renderAymingContacts());
};
export default ClaimScheduleEngagementTeam;